import { render, staticRenderFns } from "./ViewAcademy.vue?vue&type=template&id=2ea779f4&scoped=true"
import script from "./ViewAcademy.vue?vue&type=script&lang=js"
export * from "./ViewAcademy.vue?vue&type=script&lang=js"
import style0 from "./ViewAcademy.vue?vue&type=style&index=0&id=2ea779f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea779f4",
  null
  
)

export default component.exports